import { makeGet, makeRequest } from '@monjin/data';
import { renameKeys } from '@monjin/data/map';
import { fetchBody, makeSearchParams } from '@monjin/data/util';

import { NewMember } from '@model/candidate';
import { TimeZone } from '@monjin/data/model/Profile';
import { fetchData } from './util';

const encoder = renameKeys({ email: 'userEmail' });

export function createMember(member: NewMember) {

    const url = '/api/candidates';

    const payload = encoder(member);

    return fetchData(makeRequest('POST', url, payload))
        .then((_x) => member);
}

export function checkEmailAvailability(email: string, userType: string, source: number): Promise<boolean> {
    const url = `/__/a/22/1/1/17/usr/UserRoleCheck?$filter=email eq '${email}' and userType eq '${userType}' and source eq ${source}`;

    return fetchBody(makeGet(url))
        .then((x) => x.length > 0);
}

export function getUserProfileId(userId: number): Promise<number> {
    const url = `/_/a/22/1/2/${userId}/usr/UserProfile`;

    return fetchBody(makeGet(url))
        .then((x) => x.id);
}

export function getCandidateProfile(userId: number) {
    const params = makeSearchParams({
        $filter: `userId eq ${userId}`,
        include: 'BlacklistedOrganizations'
    }).toString();

    const url = `/_/a/22/1/2/${userId}/cnd/profile?${params}`;

    return fetchBody(makeGet(url))
        .then((response) => response[0]);
}

export function updateCandidateProfile(userId: number, payload) {
    const url = `/_/a/22/1/2/${userId}/cnd/profile`;

    const request = makeRequest('PATCH', url, payload);

    return fetchBody(request);
}

export function modifyMemberTimezone(userId: number, timeZoneId: number): Promise<TimeZone> {
    const payload: any = { timeZoneId };
    const url = `/_/a/22/1/1/${userId}/usr/Setting`;
    const request = makeRequest('PATCH', url, payload);

    return fetchBody(request).then((response) => {
        const timezone: TimeZone = {
            id: response.timeZoneId,
            name: response.timezoneLabel,
            offset: response.offSet
        };
        return timezone;
    });
}
